<div class="main-layout">
  <app-loading-bar [active]="isLoggingOut()" [progress]="logoutProgress()" />

  <header class="main-layout__header">
    <button type="button" class="main-layout__logo-btn" (click)="goToDashboard()" aria-label="Ir al inicio">
      <img src="/icons/logo-claro.svg" alt="Claro" class="main-layout__logo" />
    </button>
    <div class="main-layout__user-info">
      <!-- POS Selector -->
      @if (posNumbers().length > 0) {
      <div class="main-layout__pos-selector">
        <button type="button" class="main-layout__pos-trigger" (click)="togglePosDropdown()"
          [attr.aria-expanded]="isPosDropdownOpen()" aria-haspopup="listbox" aria-label="Seleccionar número POS">
          <svg class="main-layout__pos-icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2">
            <rect x="2" y="3" width="20" height="14" rx="2"></rect>
            <path d="M8 21h8M12 17v4"></path>
          </svg>
          <span class="main-layout__pos-label">
            {{ selectedPos() ? selectedPos()!.number : 'Seleccionar POS' }}
          </span>
          <svg class="main-layout__pos-chevron" [class.main-layout__pos-chevron--open]="isPosDropdownOpen()" width="14"
            height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </button>

        @if (isPosDropdownOpen()) {
        <ul class="main-layout__pos-dropdown" role="listbox" aria-label="Números POS disponibles">
          @for (pos of posNumbers(); track pos.number) {
          <li class="main-layout__pos-option"
            [class.main-layout__pos-option--selected]="selectedPos()?.number === pos.number" role="option"
            [attr.aria-selected]="selectedPos()?.number === pos.number" (click)="selectPos(pos)">
            <span class="main-layout__pos-option-id">{{ pos.number }}</span>
          </li>
          }
        </ul>
        }
      </div>
      }

      <div class="main-layout__user-details">
        <div class="main-layout__user-menu">
          <button
            type="button"
            class="main-layout__user-trigger"
            (click)="toggleUserMenu()"
            [attr.aria-expanded]="isUserMenuOpen()"
            aria-haspopup="menu"
            aria-label="Menú de usuario">
            <svg class="main-layout__user-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <span class="main-layout__user-name">{{ userName() }}</span>
            <svg class="main-layout__user-chevron"
              [class.main-layout__user-chevron--open]="isUserMenuOpen()"
              width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" aria-hidden="true">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </button>

          @if (isUserMenuOpen()) {
          <ul class="main-layout__user-dropdown" role="menu" aria-label="Opciones de usuario">
            <li role="none">
              <button
                type="button"
                class="main-layout__user-dropdown-item"
                role="menuitem"
                (click)="isUserMenuOpen.set(false); goToProfile()">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
                Perfil
              </button>
            </li>
            <li class="main-layout__user-dropdown-divider" role="none" aria-hidden="true"></li>
            <li role="none">
              <button
                type="button"
                class="main-layout__user-dropdown-item main-layout__user-dropdown-item--danger"
                role="menuitem"
                (click)="isUserMenuOpen.set(false); logout()">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" aria-hidden="true">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                  <polyline points="16 17 21 12 16 7"></polyline>
                  <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
                Cerrar sesión
              </button>
            </li>
          </ul>
          }
        </div>

        <span [class]="'main-layout__gps-status main-layout__gps-status--' + gpsCssModifier()"
          [attr.aria-label]="gpsLabel()">
          @if (gpsStatusValue() === 'requesting') {
          <span class="main-layout__gps-spinner"></span>
          } @else {
          <span class="main-layout__gps-dot"></span>
          }
          <span class="main-layout__gps-label">GPS</span>
        </span>
      </div>
    </div>
  </header>

  <main class="main-layout__content">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>

  @if (tokenService.showExpirationWarning()) {
  <app-session-expiration-modal />
  }

  @if (inactivityService.showInactivityWarning()) {
  <app-inactivity-modal />
  }
</div>